import { render, staticRenderFns } from "./VenN_AddressList_List.vue?vue&type=template&id=8318ff38"
import script from "./VenN_AddressList_List.vue?vue&type=script&lang=js"
export * from "./VenN_AddressList_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports